<template>
  <div class="about">
<!--body content start-->

<div id="main-page" class="page-content">

<!--about start-->

<section class="pb-0 z-index-1 pos-r o-hidden">
 <div class="inside-text">
    <span>About</span>
  </div>
  <div class="container">
     <div class="row justify-content-center text-center">
      <div class="col-md-10">
        <h4 class="text-black font-w-5 line-h-2">Agencio far away behind the word mountains <span class="text-theme">Agency</span> like you. With useful features an interface and <span class="text-theme">powerful Design</span> built by a community of developers, there live the blind texts.</h4>
      </div>
    </div>
    <div class="row mt-5">      
      <div class="col-lg-6 col-12 mr-auto pr-lg-5 order-lg-1">
        <div class="section-title mb-4">
          <h6>About US</h6>
          <h2 class="title">Agencio Build Branded Design</h2>          
        </div>
        <ul class="list-unstyled list-icon">
          <li class="mb-4"> <i class="fas fa-check"></i> Lorem ipsum dolor sit</li>
          <li class="mb-4"> <i class="fas fa-check"></i> Molestias, eum odio dolorem</li>
          <li class="mb-4 mb-sm-0"> <i class="fas fa-check"></i> Eum nihil expedita dolorum </li>
          <li> <i class="fas fa-check"></i> Explicabo perferendis</li>
        </ul>
        <p class="mt-4">Agencio discovering the source behind the ubiquitous filler text In seeing behind, discovering the source behind the ubiquitous filler text In seeing behind</p>
      </div>
      <div class="col-lg-6 col-12 mt-5 mt-lg-0">
        <img class="img-fluid w-100" src="images/about/01.jpg" alt="">
      </div>
    </div>
  </div>
</section>

<!--about end-->


<!--service start-->

<section class="pos-r py-15 z-index-0 o-hidden dark-bg custom-mt-10">
  <div class="inside-text">
    <span>Service</span>
  </div>
  <div class="container">
    <div class="row align-items-end mb-5">
      <div class="col-lg-6 col-12">
        <div class="section-title mb-0">
          <h6>What We Offer</h6>
          <h2 class="title mb-0">Building Brands More Quickly</h2>
        </div>
      </div>
      <div class="col-lg-6 col-12 md-mt-5">
        <p class="lead text-light font-w-5 mb-0">Agencio discovering the source behind the ubiquitous filler text In seeing a sample of lorem ipsum, his interest was piqued by consectetur Agencio discovering</p>
      </div>
    </div>
  </div>
</section>

<section class="custom-mt-10 pt-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="owl-carousel" data-items="3" data-md-items="2" data-sm-items="1" data-autoplay="true">
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-domain"></i>
              </div>
              <div class="featured-title">
                <h5>Web Development</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4 active">
              <div class="featured-icon"> <i class="flaticon-analytics"></i>
              </div>
              <div class="featured-title">
                <h5>Data Analytics</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-challenges"></i>
              </div>
              <div class="featured-title">
                <h5>Strategy</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-ui"></i>
              </div>
              <div class="featured-title">
                <h5>UX Design</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="featured-item style-4">
              <div class="featured-icon"> <i class="flaticon-histogram"></i>
              </div>
              <div class="featured-title">
                <h5>Marketing</h5>
              </div>
              <div class="featured-desc">
                <p>Design professionals, there's a bit of controversy the filler text Agencio</p>
                <a class="btn btn-white mt-5" href="#"><span>Learn More <i class="fas fa-plus-square"></i></span></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--service end-->


<section class="pt-0">
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-12">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-md-0 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-12 mt-5">
        <div class="accordion">
          <div class="card">
            <div class="card-header">
              <h6 class="mb-0">
              consectetur adipisicing elit, sed ?
              </h6>
            </div>
            <div class="card-body">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmodas temporo incididunt ut labore et dolore magna aliqua.</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<!--testimonial start-->

<section class="pb-0 pos-r" data-bg-img="images/bg/06.png">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="owl-carousel" data-items="2" data-md-items="2" data-sm-items="1" data-autoplay="true">
          <div class="item">
            <div class="testimonial style-2">
                  <div class="testimonial-content">
                    <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                    <p>Eeque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/01.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Alvi Miller</h5>
                      <label>Founder of Agencio</label>
                    </div>
                  </div>
                </div>
          </div>
          <div class="item">
            <div class="testimonial style-2">
                  <div class="testimonial-content">
                    <div class="testimonial-quote"><i class="flaticon-left-quote"></i>
                </div>
                    <p>Reasonable porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam tempora</p>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="testimonial-img">
                      <img class="img-fluid" src="images/testimonial/02.jpg" alt="">
                    </div>
                    <div class="testimonial-caption">
                      <h5>Albert Jonson</h5>
                      <label>CEO of Agencio</label>
                    </div>
                  </div>
                </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--testimonial end-->


<!--blog start-->

<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 col-12">
        <div class="section-title">
          <h6>What We Offer</h6>
          <h2 class="title">Read Our Latest News</h2>
          <p>Agencio discovering the source behind the ubiquitous filler text. In seeing a sample of lorem ipsum, his interest was piqued by consectetur</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 col-12">
        <div class="post style-4">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/01.jpg" alt="">
            <a class="post-categories" href="#">Agency</a>
          </div>
          <div class="post-desc">            
            <div class="post-title">
              <h5><a href="blog-single.html">We Develop Digital Strategy</a></h5>
            </div>
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 mt-5 mt-md-0">
        <div class="post style-4">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/02.jpg" alt="">
            <a class="post-categories" href="#">Agency</a>
          </div>
          <div class="post-desc">            
            <div class="post-title">
              <h5><a href="blog-single.html">These guide Designing work</a></h5>
            </div>
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-12 mt-5 mt-md-0">
        <div class="post style-4">
          <div class="post-image">
            <img class="img-fluid w-100" src="images/blog/large/03.jpg" alt="">
            <a class="post-categories" href="#">Agency</a>
          </div>
          <div class="post-desc">            
            <div class="post-title">
              <h5><a href="blog-single.html">We're Nominated To Agency</a></h5>
            </div>
            <div class="post-meta">
              <ul class="list-inline">
                <li><a href="#">Admin</a>
                </li>
                <li>February 08, 2020</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!--blog end-->

</div>

<!--body content end--> 


  </div>
</template>

<script>

export default {
  data: function () {
      return {
        name: "About",
      }
  },
};
</script>
